export const useDynamicYieldValues = () => {
  const dynamicState = {
    values: {
      // 24/7
      dynamicYield: '6.50',
      dynamicGATNominal: '6.72',
      dynamicGATReal: '2.64',
      // 7 DAYS
      dynamicYield7Days: '6.55',
      dynamicGATNominal7Days: '6.77',
      dynamicGATReal7Days: '2.69',
      // 28 DAYS
      dynamicYield28Days: '6.60',
      dynamicGATNominal28Days: '6.82',
      dynamicGATReal28Days: '2.74',
      // 90 days
      dynamicYield90Days: '6.70',
      dynamicGATNominal90Days: '6.93',
      dynamicGATReal90Days: '2.85',
      // 180 days
      dynamicYield180Days: '6.80',
      dynamicGATNominal180Days: '7.04',
      dynamicGATReal180Days: '2.95',
      // Cajitas Turbo
      dynamicYieldTurbo: '13.00',
      dynamicGATNominalTurbo: '13.88',
      dynamicGATRealTurbo: '9.53',
    },
    textTemplates: {
      VALUES_CALCULATED_AT: '25 de septiembre de 2026',
      MINIMUM_SAVINGS_AMOUNT: '$0.01',
      FROZEN_MINIMUM_SAVINGS_AMOUNT: '$50.00',
      VALID_UNTIL: '18 de noviembre de 2026',
      VALUES_CALCULATED_AT_CAJITA_TURBO: '25 de septiembre de 2026',
      VALID_UNTIL_CAJITA_TURBO: '18 de noviembre de 2026',
      VALID_FROM_CAJITA_TURBO: '8 de octubre de 2026',
      ADDITIONAL_DISCLAIMER_BULLETS: [
        '* Recuerda que, en términos de tu contrato, la tasa de interés anual de la Cajita 24/7 es de 6%; sin embargo, actualmente Nu te otorga una tasa promocional preferencial de 6.50% anual.',
        'Las tasas de rendimiento se presentan antes de impuestos.',
      ],
    },
  };

  return dynamicState;
};

export const FROZEN_TIME = {
  A_180_DAYS: 180,
  A_90_DAYS: 90,
  A_28_DAYS: 28,
  A_7_DAYS: 7,
  NO_FROZEN_TURBO: 1,
  NO_FROZEN: 0,
};
